import SignatureForm from './SignatureForm';

export default function FooterView() {
  return (
    <tfoot>
      <tr>
        <td colSpan={13}>
          <div className="py-2 text-center font-bold print:text-[0.6rem]">
            This form shall be verified monthly to ensure that the requirement
            still exists and re-signed annually when the temporary issued period
            exceeds one year.
            <br />
            Ce formulaire doit être vérifié mensuellement afin de s'assurer que
            le besoin existe toujours et re-signé annuellement si la période de
            prêt dépasse un an.
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan={13} className="print:text-[0.7rem]">
          ACKNOWLEGEMENT BY INDIVIDUAL OF RECEIPT OF STORES LISTED IN: – ACCUSÉ
          DE RÉCEPTION DES MARCHANDISES INDIQUÉES À LA :
        </td>
      </tr>
      <tr>
        <td colSpan={13}>
          <SignatureForm />
        </td>
      </tr>
    </tfoot>
  );
}
